import { Toaster as Sonner } from 'sonner';
import { CheckCircle, XCircle } from 'lucide-react';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg items-center gap-3 px-4 py-3 rounded-lg border data-[type=success]:bg-green-50 data-[type=success]:border-green-200 data-[type=success]:text-green-800 data-[type=error]:bg-red-50 data-[type=error]:border-red-200 data-[type=error]:text-red-800',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      icons={{
        success: <CheckCircle className="w-5 h-5 text-green-600" />,
        error: <XCircle className="w-5 h-5 text-red-600" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
